module.exports = __webpack_public_path__ + "static/img/home_img_phone.4248787.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_img_phone.png
// module id = UPtq
// module chunks = 1